<style lang='less' scoped>
*{margin: 0;list-style-type:none;}
.center{width: 100%;display: flex;flex-direction: column;background: #fff;position: relative;}
.centers{width: 100%;display: flex;flex-direction: column;background: #fff;position: relative;}
.country{width:1200px;margin: auto;}
.first{display: flex;flex-direction: column;margin: auto;height:4010px;}
.dt1{position: absolute;left: 0;right: 0;background: url('../../../../static/images/官网首页/bg.png')no-repeat;background-size: 100% 100%;}
.dt1_center{width: 1200px;margin: 0px auto; background-color: white;}
.qyzx{display: flex;flex-direction: column; width: 1200px; margin: auto;margin-left: 0px;}
.zxcontent{display: flex;justify-content:space-around;margin-top: 10px;}
.block{width: 774px; margin-left: 0px;}
.block h3{line-height: 50px;text-align: left;}
.real-time{width:340px; height: 609px;}
.dt2{position: absolute;left: 0;right: 0;top: 1129px;}
.dt2_center{margin: 0px auto; background-color: white;}
.picture{background: url('../../../../static/images/官网首页/image_bg.png')no-repeat;background-size: 100% 100%;height: 319px;}
.kyyzt{width: 406px;height: 257px;cursor: pointer;margin: 31px 97px;}
.fwVideo{display: flex;width: 1200px;margin: 0px auto;}
.bannerbox {background-color: #f8f9fb;}
.banner{width: 1200px;margin: 0px auto;}

.sticky{position: sticky; top: 240px;margin: 0px;width:200px;height: 150px;z-index: 99;}
.zxfl{position: fixed;right: 8px;float: right;width:100px;height: 380px;margin: 0;font-size: 12px;color:#0050a5;background-color: #d7eefb;border-radius: 10px 0 0 10px;}
.zxfw, .flfw{width:80px;height: 60px;margin: 10px auto;border-top: solid 1px white;
  img{margin-top: 10px;}}
  .zxfw:hover, .flfw:hover{cursor: pointer;}
.zxservice{position: absolute;right: 5.2%;top: 0.8%;z-index: 10;}
.flservice{position: absolute;right: 5.2%;top: 2.5%;margin-left: -10px;z-index: 10;}

.marquee{width: 490px; margin: 1px auto;margin-left: 10px; font-size: 16px;color: rgb(50, 128, 173);}
/deep/.vjs-big-play-button{left: 0;right: 0;top: 0;bottom: 0;margin: auto;}
.xsyz{margin: 20px auto;cursor: pointer;}
.swiperCard{position: relative;width:1200px;height:390px;overflow:hidden;margin: 0px auto;}
.ZJZK, .DMDX, .KQTJ, .kslj{list-style: none; display: flex;margin-left: -50px;
  li{margin: 0px 10px;font-size: 20px;color:rgb(131, 130, 130)}
  li:first-child{font-weight: 600;color:rgb(31, 104, 192);}
  li:hover{cursor: pointer;}
}
.ZBYS, .KYSB{
  list-style: none; display: flex;
  li{margin: 0px 10px;font-size: 20px;color:rgb(131, 130, 130)}
  li:first-child{font-weight: 600;color:rgb(31, 104, 192);}
  li:hover{cursor: pointer;}
}
.sameline1,.sameline2,.sameline3{position: relative; height: 25px;display: flex;justify-content: space-between;width: 1170px;align-items: center;margin-left: 10px;margin-top: 10px;width: 1200px;margin: 0px auto;}
.sameline4,.sameline5{position: relative; height: 25px;display: flex;justify-content: space-between;width: 595px;align-items: center;margin-left: -40px;margin-top: 10px;}
.imgmainbox {background-color: #f8f9fb;}
.imgmain {width: 1200px;margin: 0px auto;}
h3{text-align: left;margin:0;font-size: 18px;}
.gengduo{line-height: 50px;font-size: 14px;}
.gengduo:hover{color: rgb(63, 124, 202); cursor: pointer;}
.SwiperGroup1{margin-left: 10px;}
.prev{position: absolute;top:190px;left:-55px;width: 38px;height: 38px;background: url('../../../../static/images/官网首页/pre.png') no-repeat;background-size: 36px 36px; background-color: #ffffff;box-shadow: 0px 1px 3px 1px rgb(223, 222, 222); }
.next{position: absolute;top:190px;left:1185px;width: 38px;height: 38px;background: url('../../../../static/images/官网首页/next.png') no-repeat;background-size: 36px 36px; background-color: #ffffff;box-shadow: 0px 1px 3px 1px rgb(223, 222, 222); }
.listdata{position: absolute;top: 3px;left:1110px;width: 100px;font-size: 16px;border-radius: 5px;z-index: 1;}
.listdata:hover{color: rgb(31, 104, 192); cursor: pointer;}
.container1{width: 1200px;}
.container2{width: 1200px;}
.container3{width: 1200px;}
.swiper{list-style: none; display: flex;width: 5600px;}
.kysbbox {background-color: #f8f9fb;}
.myli{position: relative; width: 278px;height:330px;overflow: hidden;margin: 20px 10px;box-shadow: 0px 0px 3px 2px rgb(240, 239, 239);cursor: pointer;transition: transform .5s;border: solid 1px rgb(177, 176, 176);
  .pic{width:280px;height:160px;}
  .title{font-size: 14px;font-weight: 600;margin: 10px auto;}
  .introduce{font-size: 14px;margin: 0px 20px;line-height: 24px; letter-spacing:2px;display:-webkit-box;-webkit-line-clamp: 4;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;text-indent:2em;text-align: justify}
}
.myli:hover{transform: scale(1.2,1.2);z-index: 1;box-shadow: 0px 0px 3px 1px rgb(240, 239, 239);z-index: 99;}
.kslj{width: 1200px;height:140px;margin: 0px; margin-top: 0px;margin: 0px auto;
  h3{line-height: 60px;text-align: left;color: #08032b;margin-left: 10px;}
  p{margin-top: 8px;margin-left: 10px;}
}
.videoShow{width: 590px;margin-left: 5px;background: url('../../../../static/images/官网首页/dt_2.png')no-repeat;background-size: 100% 100%;}
.vitrual{position: relative;margin-top: 20px;
  .photoTitle{position:absolute; top: 252px;left: 7px; width: 566px;height: 20px; background-color: #1f1f1fc4;color:white;text-align: left;padding: 10px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
  .prevVideo{position: absolute;top: 330px;left:6px;width: 20px;height: 34px;cursor: pointer;z-index: 99;}
  .nextVideo{position: absolute;top: 330px;left:573px;width: 20px;height: 34px;cursor: pointer;z-index: 99;}
  .swiperVideo{position: relative;width:600px;overflow: hidden;margin: 0;
    .container{width: 600px;margin: 0;}
    ul{list-style: none;display: flex;width: 2000px;padding: 0;margin-left: 1px;}
  }
}
.fastlink{position: relative;width:1200px;height:280px;overflow:hidden;margin: 0 auto;}
.earthgroup{position: relative;width:1200px;overflow:hidden;margin: 0 auto;
  .buttonul{width:1200px;margin: 0;padding: 0;list-style: none;display: flex;justify-content: space-around;}
  .el-button{width: 290px;height: 62px;font-size: 18px;line-height: 35px;margin-bottom: 10px;
    i{margin-left: 30px;}
  }
}
.earthdata{position: relative;width:1190px;height:240px;overflow:hidden;margin-left: 10px;box-shadow: 0px 0px 6px 0px
rgba(0, 0, 0, 0.16);border-radius: 4px;z-index: 10000;background-color: #ffffff;text-align: left;margin: 0 auto;
  .zz::before {content: "|";width: 4px; height:26px;background-color: #00338b;margin-left: 10px;margin-right: 20px;}
  .zz{font-family: Microsoft YaHei;font-size: 18px;font-weight: bolder;font-stretch: normal;line-height: 35px;letter-spacing: 1px;color: #00338b;margin-left: 10px;margin-top: 10px;}
  
  .zzul{width:1190px;margin: 0;margin-top: 16px;padding: 0;list-style: none;display: flex;flex-wrap: wrap;
    li{position: relative; width: 224px;height:60px;overflow: hidden; border-radius: 4px;border: solid 1px #e6e6e6;margin: 8px 0px;margin-left: 10px;display: flex;}
    li:hover{cursor: pointer;}
    img{margin: 14px 10px;width:50px; height: 32px;vertical-align: middle;}
    .zzname{font-family: Microsoft YaHei;font-size: 14px;letter-spacing: 1px;margin-top: 10px;}
    }
}
.messagecenter{position: fixed ;z-index: 10;right: 16.9%; top: 23%;}
.feedback{position: fixed ;z-index: 1000;right: 33%; top: 25%;}
.cjquestion{position: fixed ;z-index: 10;right: 32.8%; top: 20%;background-color: #fff;}
.legalserice{position: fixed ;z-index: 10;right: 32.8%; top: 25%;background-color: #fff;}
.kyzxservice{position: fixed ;z-index: 10;right: 32.8%; top: 25%;background-color: #fff;}
/deep/.el-dialog{width: 33%;height: 300px;}
</style>

<template>
  <div class="center">
    <div class="first">
      <div class="dt1">
        <div class="dt1_center">
          <div class="qyzx">
            <div class="zxcontent">
              <div class="block">
                <NewSwiperImg :widthCSH="774" :heightCSH="481" :swiperlist="Swiperlist" @clickSwiper="goDetails"></NewSwiperImg>
                <NewNational></NewNational>
              </div>
              <div class="real-time">
                <NewHotNews :headlines="Headlines" :hotNewslist="HotNewslist" @clickHotNews="goDetailsHN"></NewHotNews>
              </div>
            </div>
          </div>
          <TabsCard></TabsCard>
        </div>
      </div>
      
      <div class="dt2">
        <div class="picture">
          <img class="kyyzt" src="static/images/官网首页/image_DP.png" @click="goExhibition">
          <img class="kyyzt" src="static/images/官网首页/image_DT.png" @click="goLargeScreen">
        </div>
      
        <div class="dt2_center">
          <div class="fwVideo">
            <div class="vitrual" style="position: relative;" @mouseover="mouseOver2()" @mouseleave="mouseLeave2()">
              <div class="video" @click="goPhotoList(photoid)">
                <img :src="photo" style="width: 586px; height: 292px;cursor: pointer;" />
                <p class="photoTitle">{{ photoTitle }}</p>
              </div>
              <img v-if="isShow2" class="prevVideo" src="../../../../static/index/icon_slide_left.png" alt="" @click="prevVideo2">
              <img v-if="isShow2" class="nextVideo" src="../../../../static/index/icon_slide_right.png" alt="" @click="nextVideo2">
              <div class="swiperVideo">
                <div class="container" :style="{'margin-left': marginLeftP + 'px'}">
                  <ul>
                    <li v-for="(item,index) in photoList" :key="index">
                      <img :src="item.thumb" style="width: 141px;height: 94px;margin: 5px 4px;border-radius: 5px;cursor: pointer;" @click="getPIC(item)" />
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="vitrual" style="position: relative;" @mouseover="mouseOver()" @mouseleave="mouseLeave()">
              <div class="video">
                <div v-if="playerOptions.sources[0].src===''">视频播放失败</div>
                <video-player class="videoShow" ref="videoPlayer" v-else :playsinline="true" :options="playerOptions"></video-player>
              </div>
              <img v-if="isShow" class="prevVideo" src="../../../../static/index/icon_slide_left.png" alt="" @click="prevVideo">
              <img v-if="isShow" class="nextVideo" src="../../../../static/index/icon_slide_right.png" alt="" @click="nextVideo">
              <div class="swiperVideo">
                <div class="container" :style="{'margin-left': marginLeft0 + 'px'}">
                  <ul>
                    <li v-for="(item,index) in videoList" :key="index">
                      <img :src="item.thumb" style="width: 141px;height: 94px;margin: 5px 4px;border-radius: 5px;cursor: pointer;" @click="getPlayerOptions(item)" />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="bannerbox">
            <div class="banner">
              <img class="xsyz" src="static/images/官网首页/image_1.png" @click="onKylt" />
              <img class="xsyz" src="static/images/官网首页/image_2.png" @click="onXsyz" />
              <img class="xsyz" src="static/images/官网首页/image_4.png" @click="onRcep"/>
              <img class="xsyz" src="static/images/官网首页/image_3.png" @click="onHyzj"/>
            </div>
          </div>
          <div class="sameline2" style="margin-top: 20px;">
            <ul class="ZJZK">
              <li v-for="(item,index) in ZJZKList" :key="index" @click="getZjzk(item, index)">{{ item.name }}</li>
            </ul>
            <el-button class="prev" @click="prev2" circle></el-button>
            <el-button class="next" @click="next2" circle></el-button>
            <p class="listdata" size="medium" @click="goZJZK">更多</p>
          </div>

          <div class="swiperCard">
            <div class="container2" :style="{'margin-left': marginLeft2 + 'px'}">
              <ul class="swiper">
                <li class="myli"  v-for="(item,index) in swiperCarddata2" :key="index" @click="goZJZKDetails(item)" style="background: rgb(222, 252, 253);">
                  <img class="pic" :src="item.thumb" />
                  <div style="margin: 0px 10px;">
                    <p class="title">{{ item.title }}</p>
                  </div>
                  <div style="">
                    <p class="introduce">{{ item.introduce }}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="sameline3">
            <ul class="DMDX">
              <li v-for="(item,index) in DMDXList" :key="index" @click="getDmdx(item, index)">{{ item.name }}</li>
            </ul>
            <p class="listdata" size="medium" @click="goDMDX">更多</p>
          </div>

          <div class="imgmainbox">
            <div class="imgmain">
              <ImgMain :imgMainList="swiperCarddata3" @handleClick="goPDF"></ImgMain>
            </div>
          </div>
          <!-- <div class="swiperCard">
            <div class="container3" :style="{'margin-left': marginLeft3 + 'px'}">
              <ul class="swiper">
                <li class="myli"  v-for="(item,index) in swiperCarddata3" :key="index" @click="goPDF(item)" style="background: rgb(219, 242, 253);">
                  <img class="pic" :src="item.thumb" />
                  <div style="margin: 0px 10px;">
                    <p class="title">{{ item.title }}</p>
                  </div>
                  <div style="">
                    <p class="introduce">{{ item.introduce }}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div> -->
          <div class="sameline1">
            <ul class="KQTJ">
              <li v-for="(item,index) in KQTJList" :key="index" @click="getKqtj(item,index)">{{ item.name }}</li>
            </ul>
            <el-button class="prev" @click="prev1" circle></el-button>
            <el-button class="next" @click="next1" circle></el-button>
            <p class="listdata" size="medium" @click="goKQTJ">更多</p>
          </div>

          <div class="swiperCard">
            <div class="container1" :style="{'margin-left': marginLeft1 + 'px'}">
              <ul class="swiper">
                <li class="myli"  v-for="(item,index) in swiperCarddata1" :key="index" @click="goKYXM(item)" style="background: rgb(198, 237, 250);">
                  <img class="pic" :src="item.thumb" />
                  <div style="margin: 0px 10px;">
                    <p class="title">{{ item.title }}</p>
                  </div>
                  <div style="">
                    <p class="introduce">{{ item.introduce }}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="kysbbox">
            <div style="display: flex;width: 1200px;margin: 0px auto">
              <div>
                <div class="sameline4">
                  <ul class="KYSB">
                    <li v-for="(item,index) in KYSBList" :key="index" @click="getKysb(item, index)">{{ item.name }}</li>
                  </ul>
                  <span class="gengduo" @click="onKysbList">更多</span>
                </div>
                <SwiperGroup1 class="SwiperGroup1" :swiperGroupList="swiperGroupKYSB" @clickSwiper="onclickSwiperKYSB"></SwiperGroup1>
              </div>
              <div style="margin-left: 10px;">
                <div class="sameline5">
                  <ul class="ZBYS">
                    <li v-for="(item,index) in ZBYSList" :key="index" @click="getZbys(item,index)">{{ item.name }}</li>
                  </ul>
                  <span class="gengduo" @click="onZbysList">更多</span>
                </div>
                <SwiperGroup1 class="SwiperGroup1" :swiperGroupList="swiperGroupZBYS" @clickSwiper="onclickSwiperZBYS"></SwiperGroup1>
              </div>
            </div>
          </div>

          <div class="sameline1" style="margin-top: 20px;">
            <ul class="KQTJ">
              <li><i class="el-icon-link"></i>快速链接</li>
            </ul>
          </div>

          <div class="fastlink">
            <div class="container1" style="display: flex;margin-top:10px;">
              <a href="http://www.mnr.gov.cn/"><img src="../../../../static/images/官网首页/firstlink/ksrk_logo1.png" alt=""></a>
              <a href="http://www.gxzf.gov.cn/"><img src="../../../../static/images/官网首页/firstlink/ksrk_logo2.png" alt="" style="margin-left:-12px"></a>
              <a href="https://www.cgs.gov.cn/"><img src="../../../../static/images/官网首页/firstlink/ksrk_logo3.png" alt="" style="margin-left:-12px"></a>
              <a href="https://dnr.gxzf.gov.cn/"><img src="../../../../static/images/官网首页/firstlink/ksrk_logo4.png" alt="" style="margin-left:-12px"></a>
            </div>
            <div style="display: flex;">
              <a href="http://fgw.gxzf.gov.cn/"><img src="../../../../static/images/官网首页/firstlink/ksrk_logo5.png" alt=""></a>
              <a href="https://www.caexpo.org/"><img src="../../../../static/images/官网首页/firstlink/ksrk_logo6.png" alt="" style="margin-left:-6px"></a>
              <a href="http://dkj.gxzf.gov.cn/"><img src="../../../../static/images/官网首页/firstlink/ksrk_logo7.png" alt="" style="margin-left:-6px"></a>
            </div>
          </div>
          <div class="earthgroup" @mouseover="mouseOverZZ()" @mouseleave="mouseLeaveZZ()">
            <ul class="buttonul">
              <li v-for="(item, index) in earthgroupList" :key="index">
                <el-button @click="selectZZ(index)">{{item}}<i class="el-icon-arrow-down"></i></el-button>
              </li>
            </ul>
            <div class="earthdata" v-if="isZZBoxShow">
              <p class="zz" v-if="isZZshow === 0">中国地球科学组织</p>
              <p class="zz" v-if="isZZshow === 1">东盟国家地球科学组织</p>
              <p class="zz" v-if="isZZshow === 2">世界地球科学组织</p>
              <p class="zz" v-if="isZZshow === 3">其它链接</p>
              <ul class="zzul">
                <li v-for="(item, index) in zzList" :key="index" @click="goZZ(item.url)">
                  <img :src="item.thumb"/>
                  <p class="zzname">{{item.name}}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 常见问题 -->
      <!-- <div class = "cjquestion" v-show="">
        <CJQuestion></CJQuestion>
      </div> -->
      <div @mouseleave="closeKyzxfw">
        <ZXService class="zxservice" v-if="isdialogVisible1"></ZXService>
        <FLService class="flservice" v-if="isdialogVisible2"></FLService>
      </div>
      <div class="sticky" >
        <div class="zxfl">
          <div class="zxfw" @click="openMessage" @mouseover="showMessage">
            <img src="static/images/官网首页/ic_xxzx.png" />
            <p>消息中心</p>
          </div>
          <div class="zxfw" @click="openKyzxfw" @mouseover="showKyzxfw">
            <img src="static/images/官网首页/icon_kyczxfw.png" />
            <p>矿业咨询服务</p>
          </div>
          <div class="flfw" @click="openFlfw" @mouseover="showFlfw">
            <img src="static/images/官网首页/ic_flfw.png" />
            <p>法律服务</p>
          </div>
          <div class="flfw" @click="feedBack" @mouseover="showMessage">
            <img src="static/images/官网首页/icon_feedback.png" />
            <p>反馈及建议</p>
          </div>
          <div class="flfw" @click="comProblem" @mouseover="showMessage">
            <img src="static/images/官网首页/icon_cp.png" />
            <p>常见问题</p>
          </div>
        </div>
      </div>
      <MessageCenter class="messagecenter" v-show="ismesssageShow"></MessageCenter>
      <FeedBack class="feedback" v-show="isfeedBack"></FeedBack>
      <CJQuestion class = "cjquestion" v-show="iscomProblemShow"></CJQuestion>
      <LegalService class = "legalserice" v-show="islegalShow"></LegalService>
      <KYZXService class = "kyzxservice" v-show="isopenKyzxfwShow"></KYZXService>
      <el-dialog title="会员之家" :visible.sync="dialogFormVisible">
          <div>
            <div style="border:1px solid #d7eefb;cursor: pointer;"><img src="static/index/gxhwkycylhh.png" alt="" style="width:;490px;height:90px;" @click="openMember(2)"></div>
            <div style="border:1px solid #d7eefb;margin-top:10px;cursor: pointer;"><img src="static/index/zgdxkyxxfupt.png" alt="" style="width:;490px;height:90px;" @click="openMember(1)"></div>
          </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
/**
 * 罗志远 网站首页
 */
import National from '.././assembly/National'
import NewNational from '.././assembly/NewNational'
import SwiperImg from '.././assembly/SwiperImg'
import NewSwiperImg from '.././assembly/NewSwiperImg'
import HotNews from '.././assembly/HotNews'
import NewHotNews from '.././assembly/NewHotNews'
import TabsCard from '../assembly/TabsCard'
import ZXService from '../assembly/ZXService'
import FLService from '../assembly/FLService'
import MessageCenter from '../assembly/MessageCenter'
import FeedBack from '../assembly/FeedBack'
import CJQuestion from '../assembly/CJQuestion'
import LegalService from '../assembly/LegalService'
import KYZXService from '../assembly/KYZXService'
import SwiperGroup1 from '../assembly/SwiperGroup1'
import playVideoSY from '../method/playVideoSY'
import ImgMain from '../assembly/ImgMain.vue'
import $ from 'jquery'

export default {
  components: {
    National,
    NewNational,
    SwiperImg,
    NewSwiperImg,
    HotNews,
    NewHotNews,
    TabsCard,
    ZXService,
    FLService,
    MessageCenter,
    FeedBack,
    CJQuestion,
    LegalService,
    KYZXService,
    SwiperGroup1,
    playVideoSY,
    ImgMain
  },
  name: '',
  mixins: [playVideoSY],
  data()
  {
    return {
      swiperlist: [], // 左侧轮播图
      hotNewslist: [], // 右侧新闻
      user1: '',
      content1: '',
      user2: '',
      content2: '',
      dialogFormVisible: false,
      ZJZKList: [
        {name: '专家智库', catid: 0},
        {name: '高端智库', catid: 103},
        {name: '发展规划', catid: 104},
        {name: '学术演讲', catid: 433},
        {name: '专家详说', catid: 434}
      ],
      form: {},
      DMDXList: [
        {name: '东盟地学', catid: 0},
        {name: '地球科学', catid: 423},
        {name: '矿产调查', catid: 424},
        {name: '典型矿床', catid: 425},
        {name: '生态地质', catid: 432}
      ],
      KQTJList: [
        {name: '矿权推介', ssgj: 0}
        // {name: '东盟矿权', ssgj: 5},
        // {name: '国际矿权', ssgj: 13},
        // {name: '国内矿权', ssgj: 2}
      ],
      KYSBList: [
        {name: '矿业设备', catid: 0},
        {name: '地质仪器', catid: 70},
        {name: '矿山设备', catid: 71},
        {name: '药剂溶剂', catid: 0}
      ],
      ZBYSList: [
        {name: '珠宝玉石', catid: 0},
        {name: '宝石',    catid: 65},
        {name: '玉石',    catid: 66}
      ],
      swiperCarddata1: [], // 矿权推介
      swiperCarddata2: [], // 专家智库
      swiperCarddata3: [], // 东盟地学
      marginLeft1: -40,
      marginLeft2: -40,
      marginLeft3: -40,
      swiperGroupKYSB: [], // 矿业设备数据
      swiperGroupZBYS: [], // 矿业设备数据

      photo: [], // 首页图片大图
      photoTitle: '', // 首页图片标题
      photoid: '', // 首页图id
      photoList: [], // 首页图片数组
      isfilter: true,
      videoList: [], // 首页视频下图片
      GNURL: '',
      optionsGN: [
        { id: '选项1', name: '中华人民共和国自然资源部',        value: 'http://www.mnr.gov.cn/' },
        { id: '选项2', name: '广西壮族自治区人民政府',          value: 'http://www.gxzf.gov.cn/' },
        { id: '选项3', name: '广西壮族自治区自然资源厅',        value: 'http://dnr.gxzf.gov.cn/' },
        { id: '选项4', name: '自然资源部中国地质调查局',        value: 'http://www.cgs.gov.cn/' },
        { id: '选项5', name: '中国东盟博览会',                 value: 'http://www.caexpo.org/' },
        { id: '选项6', name: '广西壮族自治区发展和改革委员会',   value: 'http://fgw.gxzf.gov.cn/' },
        { id: '选项7', name: '广西壮族自治区地质矿产勘查开发局', value: 'http://dkj.gxzf.gov.cn/' }
      ],
      GWURL: '',
      optionsGW: [
        { id: '选项1', name: '柬埔寨矿产和能源部',        value: 'http://www.mme.gov.kh' },
        { id: '选项2', name: '缅甸地质调查与矿产开发局',   value: 'http://www.mining.gov.mm' },
        { id: '选项3', name: '马来西亚矿产与地球科学部',   value: 'http://www.jmg.gov.my' },
        { id: '选项4', name: '菲律宾矿山和地球科学局',     value: 'http://mgb.gov.ph' },
        { id: '选项5', name: '印度尼西亚能源和矿产资源部', value: 'http://www.esdm.go.id' },
        { id: '选项6', name: '泰国矿产资源部',            value: 'http://www.dmr.go.th' }
      ],
      marginLeft0: 0,
      currentType: '',
      isShow: false,

      isShow2: false,
      marginLeftP: 0,

      ready: true,
      isdialogVisible1: false,
      isdialogVisible2: false,
      dialogZxfwVisible: false,
      ismesssageShow: false,
      isfeedBack: false,
      iscomProblemShow: false,
      islegalShow: false,
      isopenKyzxfwShow: false,


      isZZBoxShow: false,
      earthgroupList: ['中国地球科学组织', '东盟国家地球科学组织', '世界地球科学组织', '其它链接'],
      isZZshow: 0,
      zzList: [],
      headlines: [],
      hyzjList: []
    }
  },
  created()
  {
    this.getQyzx()
    this.getQuestion()
    this.getDmdx({}, 0)
    this.getKqtj({}, 0)
    this.getZjzk({}, 0)
    this.getKysb({}, 0)
    this.getZbys({}, 0)
    this.getPicList()
    this.getPhotoList()
    this.getzzList(0)
    this.getZz()
  },
  computed: {
    Swiperlist()
    {
      return this.swiperlist
    },
    HotNewslist()
    {
      return this.hotNewslist
    },
    player()
    {
      return this.$refs.videoPlayer.player
    },
    Headlines()
    {
      return this.headlines
    }
  },
  mounted()
  {
    //存储系统标题
    sessionStorage.setItem('title', this.$route.meta.title)
    this.$router.push({path: '/Kyforum'})
  },
  watch: {
    GNURL: {
      handler(nval, oval)
      {
        if (nval !== '') window.open(nval, '_blank')
      },
      immediate: true
    },
    GWURL: {
      handler(nval, oval)
      {
        if (nval !== '') window.open(nval, '_blank')
      },
      immediate: true
    }
  },
  methods:
  {
    /**
     * 获取前沿资讯
     */
    getQyzx()
    {
      let parass = {cmd: 'query', _major: 11, _minor: 74, _exp: 'id>0', orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 1}
      window.post.getPost(parass).then((ret) =>
      {
        this.swiperlist = []
        this.hotNewslist = []
        this.headlines = []
        if (ret[0].data.length > 0)
          this.headlines.push({id: ret[0].data[0].id, newsid: ret[0].data[0].newsid,  typeid: ret[0].data[0].typeid, pic: ret[0].data[0].thumb ? ret[0].data[0].thumb : 'static/images/moren.jpg', icon: 'static/images/zlkindex/new.png', title: ret[0].data[0].title, text: ret[0].data[0].introduce, time: ret[0].data[0].addtime, major: ret[0].data[0].major, minor: ret[0].data[0].minor})
        else
        {
          let paras = {cmd: 'query', _major: 11, _minor: 1, _exp: 'level=1 and examine = 0', orderby: 'edittime DESC', init: 0, pageno: 1, pagesize: 1}
          window.post.getPost(paras).then((ret) =>
          {
            this.headlines.push({id: ret[0].data[0].id,  catid: ret[0].data[0].catid, pic: ret[0].data[0].thumb ? ret[0].data[0].thumb : 'static/images/moren.jpg', icon: 'static/images/zlkindex/new.png', title: ret[0].data[0].title, text: ret[0].data[0].introduce, time: ret[0].data[0].addtime, major: 11, minor: 1})
          })
        }
        let paras = {cmd: 'query', _major: 11, _minor: 1, _exp: 'level=1 and examine = 0', orderby: 'edittime DESC', init: 0, pageno: 1, pagesize: 5}
        window.post.getPost(paras).then((ret) =>
        {
          ret[0].data.forEach((item, index) =>
          {
            this.hotNewslist.push({id: item.id,  catid: item.catid, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', icon: 'static/images/zlkindex/new.png', title: item.title, text: item.introduce, time: item.addtime, major: 11, minor: 1})
            this.swiperlist.push({id: item.id,  catid: item.catid, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', title: item.title, major: 11, minor: 1})
          })
        })
      })
    },
    // 获取组织
    getZz()
    {
      let parass = {cmd: 'query', _major: 11, _minor: 126, _exp: 'id>0', orderby: 'addtime ASC'}
      window.post.getPost(parass).then((ret) =>
      {
        this.hyzjList = []
        ret.forEach(val =>
        {
          this.hyzjList.push({val})
        })
      })
    },
    // 矿权推介
    getKqtj(item, index)
    {
      $(`.sameline1 ul li`).css({'font-weight': '500', 'color': 'rgb(131, 130, 130)'})
      $(`.sameline1 ul li:nth-child(${index + 1})`).css({'font-weight': '600', 'color': 'rgb(31, 104, 192)'})
      this.marginLeft1 = -40
      if (index === 0)
      {
        let paras = {cmd: 'query', _major: 11, _minor: 129, _exp: 'id>0 and examine = 0', orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 10}
        window.post.getPost(paras).then((ret) =>
        {
          this.swiperCarddata1 = []
          ret[0].data.forEach(item =>
          {
            this.swiperCarddata1.push({id: item.id, thumb: item.thumb ? item.thumb : 'static/images/moren.jpg', title: item.title, author: item.editor, introduce: item.introduce})
          })
        })
      }
      else
      {
        if (item.ssgj === 2)
        {
          let paras = {cmd: 'query', _major: 11, _minor: 129, _exp: 'ssgj=2 and examine = 0', orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 10}
          window.post.getPost(paras).then((ret) =>
          {
            this.swiperCarddata1 = []
            ret[0].data.forEach(item =>
            {
              this.swiperCarddata1.push({id: item.id, thumb: item.thumb ? item.thumb : 'static/images/moren.jpg', title: '《' + item.title + '》', author: item.editor, introduce: item.introduce})
            })
          })
        }
        else if (item.ssgj === 13)
        {
          let paras = {cmd: 'query', _major: 11, _minor: 129, _exp: 'ssgj=13 and examine = 0', orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 10}
          window.post.getPost(paras).then((ret) =>
          {
            this.swiperCarddata1 = []
            ret[0].data.forEach(item =>
            {
              this.swiperCarddata1.push({id: item.id, thumb: item.thumb ? item.thumb : 'static/images/moren.jpg', title: '《' + item.title + '》', author: item.editor, introduce: item.introduce})
            })
          })
        }
        else
        {
          let paras = {cmd: 'query', _major: 11, _minor: 12, _exp: 'ssgj>2 and ssgj<13 and examine = 0', orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 10}
          window.post.getPost(paras).then((ret) =>
          {
            this.swiperCarddata1 = []
            ret[0].data.forEach(item =>
            {
              this.swiperCarddata1.push({id: item.id, thumb: item.thumb ? item.thumb : 'static/images/moren.jpg', title: '《' + item.title + '》', author: item.editor, introduce: item.introduce})
            })
          })
        }
      }
    },
    // 专家智库
    getZjzk(item, index)
    {
      $(`.sameline2 ul li`).css({'font-weight': '500', 'color': 'rgb(131, 130, 130)'})
      $(`.sameline2 ul li:nth-child(${index + 1})`).css({'font-weight': '600', 'color': 'rgb(31, 104, 192)'})
      this.marginLeft2 = -40
      if (index === 0)
      {
        let paras = {cmd: 'query', _major: 11, _minor: 45, _exp: 'catid!=0 and examine = 0', orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 10}
        window.post.getPost(paras).then((ret) =>
        {
          this.swiperCarddata2 = []
          ret[0].data.forEach(item =>
          {
            this.swiperCarddata2.push({id: item.id, thumb: item.thumb ? item.thumb : 'static/images/moren.jpg', title: '《' + item.title + '》', author: item.author, introduce: item.introduce})
          })
        })
      }
      else
      {
        let paras = {cmd: 'query', _major: 11, _minor: 45, _exp: `catid=${item.catid} and examine = 0`, orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 10}
        window.post.getPost(paras).then((ret) =>
        {
          this.swiperCarddata2 = []
          ret[0].data.forEach(item =>
          {
            this.swiperCarddata2.push({id: item.id, thumb: item.thumb ? item.thumb : 'static/images/moren.jpg', title: '《' + item.title + '》', author: item.author, introduce: item.introduce})
          })
        })
      }
    },
    // 东盟地学
    getDmdx(item, index)
    {
      $(`.sameline3 ul li`).css({'font-weight': '500', 'color': 'rgb(131, 130, 130)'})
      $(`.sameline3 ul li:nth-child(${index + 1})`).css({'font-weight': '600', 'color': 'rgb(31, 104, 192)'})
      this.marginLeft3 = -40
      if (index === 0)
      {
        let paras = {cmd: 'query', _major: 11, _minor: 66, _exp: 'id>0 and examine = 0', orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 4}
        window.post.getPost(paras).then((ret) =>
        {
          this.swiperCarddata3 = []
          ret[0].data.forEach(item =>
          {
            this.swiperCarddata3.push({id: item.id, thumb: item.thumb ? item.thumb : 'static/images/moren.jpg', title: '《' + item.title + '》', author: item.author, introduce: item.introduce, pdf: item.pdf})
          })
        })
      }
      else
      {
        let paras = {cmd: 'query', _major: 11, _minor: 66, _exp: `catid=${item.catid} and examine = 0`, orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 4}
        window.post.getPost(paras).then((ret) =>
        {
          this.swiperCarddata3 = []
          ret[0].data.forEach(item =>
          {
            this.swiperCarddata3.push({id: item.id, thumb: item.thumb ? item.thumb : 'static/images/moren.jpg', title: '《' + item.title + '》', author: item.author, introduce: item.introduce, pdf: item.pdf})
          })
        })
      }
    },
    // 跳转到矿业论坛详情页面，并将被点击的对象的id提交到vuex
    goDetails(item)
    {
      if (item.minor === 1)
      {
        let url = this.$router.resolve({path: '/KyzxDetails', query: {id: item.id}})
        window.open(url.href, '_blank')
      }
      if (item.minor === 5)
      {
        let url = this.$router.resolve({path: '/DhxwDetails', query: {id: item.id}})
        window.open(url.href, '_blank')
      }
      if (item.minor === 12)
      {
        let url = this.$router.resolve({path: '/HzxmKYXMDetails', query: {id: item.id}})
        window.open(url.href, '_blank')
      }
      if (item.minor === 14)
      {
        let url = this.$router.resolve({path: '/HzxmKCPDetails', query: {id: item.id}})
        window.open(url.href, '_blank')
      }
      if (item.minor === 16)
      {
        let url = this.$router.resolve({path: '/HzxmZBYSDetails', query: {id: item.id}})
        window.open(url.href, '_blank')
      }
      if (item.minor === 18)
      {
        let url = this.$router.resolve({path: '/HzxmKYSBDetails', query: {id: item.id}})
        window.open(url.href, '_blank')
      }
      if (item.minor === 22)
      {
        let url = this.$router.resolve({path: '/SjgxDetails', query: {id: item.id}})
        window.open(url.href, '_blank')
      }
      if (item.minor === 24)
      {
        let url = this.$router.resolve({path: '/ZlkDetails', query: {id: item.id}})
        window.open(url.href, '_blank')
      }
      if (item.minor === 45)
      {
        let url = this.$router.resolve({path: '/ZhikuDetails', query: {id: item.id}})
        window.open(url.href, '_blank')
      }
    },
    goDetailsHN(item)
    {
      if (item.minor === 1)
      {
        let url = this.$router.resolve({path: '/KyzxDetails', query: {id: item.id}})
        window.open(url.href, '_blank')
      }
      if (item.minor === 5 && item.typeid !== 28)
      {
        let url = this.$router.resolve({path: '/DhxwDetails', query: {id: item.id}})
        window.open(url.href, '_blank')
      }
      else
      {
        let url = this.$router.resolve({path: '/LtgkDetails', query: {id: item.id}})
        window.open(url.href, '_blank')
      }
      if (item.minor === 12)
      {
        let url = this.$router.resolve({path: '/HzxmKYXMDetails', query: {id: item.id}})
        window.open(url.href, '_blank')
      }
      if (item.minor === 14)
      {
        let url = this.$router.resolve({path: '/HzxmKCPDetails', query: {id: item.id}})
        window.open(url.href, '_blank')
      }
      if (item.minor === 16)
      {
        let url = this.$router.resolve({path: '/HzxmZBYSDetails', query: {id: item.id}})
        window.open(url.href, '_blank')
      }
      if (item.minor === 18)
      {
        let url = this.$router.resolve({path: '/HzxmKYSBDetails', query: {id: item.id}})
        window.open(url.href, '_blank')
      }
      if (item.minor === 22)
      {
        let url = this.$router.resolve({path: '/SjgxDetails', query: {id: item.id}})
        window.open(url.href, '_blank')
      }
      if (item.minor === 24)
      {
        let url = this.$router.resolve({path: '/ZlkDetails', query: {id: item.id}})
        window.open(url.href, '_blank')
      }
      if (item.minor === 45)
      {
        let url = this.$router.resolve({path: '/ZhikuDetails', query: {id: item.id}})
        window.open(url.href, '_blank')
      }
      if (item.minor === 74)
      {
        let url = this.$router.resolve({path: '/KyzxDetails', query: {id: item.newsid}})
        window.open(url.href, '_blank')
      }
    },
    // 跳转到资料库详情页面
    goZLKDetails(item)
    {
      let url = this.$router.resolve({path: '/ZlkDetails', query: {id: item.id}})
      window.open(url.href, '_blank')
    },
    //前往矿业论坛
    onKylt()
    {
      let url = this.$router.resolve({path: '/Promoin'})
      window.open(url.href, '_blank')
    },
    //前往线上云展
    onXsyz()
    {
      let url = this.$router.resolve({path: '/Exhibition'})
      window.open(url.href, '_blank')
    },
    //前往Rcep
    onRcep()
    {
      let url = this.$router.resolve({path: '/Rcep'})
      window.open(url.href, '_blank')
    },
    //前往会员之家
    onHyzj()
    {
      this.dialogFormVisible = true
    },
    // 跳转到会员之家
    openMember(val)
    {
      let url = this.$router.resolve({path: '/MemberHome', query: {id: val}})
      window.open(url.href, '_blank')
    },
    onNavhead(nav)
    {
      let url = this.$router.resolve({name: nav})
      window.open(url.href, '_blank')
    },
    // 跳转到地学资料详情页
    goPDF(item)
    {
      // if (localStorage.getItem('username'))
      window.open(item.pdf, '_blank')
      // else
      // this.$message({message: '请先注册登录后再查看pdf文件内容', type: 'error', customClass: 'mzindex'})
    },
    // 跳转到矿业项目详情页
    goKYXM(item)
    {
      let url = this.$router.resolve({path: '/KyqtjDetails', query: {id: item.id}})
      window.open(url.href, '_blank')
    },
    // 跳转到矿业项目详情页
    goZJZKDetails(item)
    {
      let url = this.$router.resolve({path: '/ZhikuDetails', query: {id: item.id}})
      window.open(url.href, '_blank')
    },
    // 跳转到线上云展
    goExhibition()
    {
      let url = this.$router.resolve({path: '/LargeScreen'})
      window.open(url.href, '_blank')
    },
    // 跳转到数字大屏
    goLargeScreen()
    {
      let url = this.$router.resolve({path: '/Kyyztoply'})
      window.open(url.href, '_blank')
    },
    goKQTJ()
    {
      let url = this.$router.resolve({path: '/KyqtjList'})
      window.open(url.href, '_blank')
    },
    goZJZK()
    {
      let url = this.$router.resolve({path: '/Thinktank'})
      window.open(url.href, '_blank')
    },
    goDMDX()
    {
      let url = this.$router.resolve({path: '/Dmgeonomy'})
      window.open(url.href, '_blank')
    },
    showKyzxfw()
    {
      this.isdialogVisible1 = true
      this.isdialogVisible2 = false
    },
    showFlfw()
    {
      this.isdialogVisible2 = true
      this.isdialogVisible1 = false
    },
    closeKyzxfw()
    {
      this.isdialogVisible1 = false
      this.isdialogVisible2 = false
    },
    prev1()
    {
      if (this.marginLeft1 === -40)
        this.marginLeft1 = -((this.swiperCarddata1.length - 4) * 300 + 40)
      else
        this.marginLeft1 += 300
    },
    next1()
    {
      if (this.marginLeft1 === -((this.swiperCarddata1.length - 4) * 300 + 40))
        this.marginLeft1 = -40
      else
        this.marginLeft1 -= 300
    },
    prev2()
    {
      if (this.marginLeft2 === -40)
        this.marginLeft2 = -((this.swiperCarddata2.length - 4) * 300 + 40)
      else
        this.marginLeft2 += 300
    },
    next2()
    {
      if (this.marginLeft2 === -((this.swiperCarddata2.length - 4) * 300 + 40))
        this.marginLeft2 = -40
      else
        this.marginLeft2 -= 300
    },
    prev3()
    {
      if (this.marginLeft3 === -40)
        this.marginLeft3 = -((this.swiperCarddata3.length - 4) * 300 + 40)
      else
        this.marginLeft3 += 300
    },
    next3()
    {
      if (this.marginLeft3 === -((this.swiperCarddata3.length - 4) * 300 + 40))
        this.marginLeft3 = -40
      else
        this.marginLeft3 -= 300
    },
    // 获取用户提问数据
    getQuestion()
    {
      let paras1 = {cmd: 'query', _major: 11, _minor: 63, _exp: 'type=1', orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 1}
      window.post.getPost(paras1).then((ret) =>
      {
        let str1 = ret[0].data[0].user
        this.user1 = str1.substr(0, 3) + '********'
        this.content1 = ret[0].data[0].content
      })
      let paras2 = {cmd: 'query', _major: 11, _minor: 63, _exp: 'type=2', orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 1}
      window.post.getPost(paras2).then((ret) =>
      {
        let str2 = ret[0].data[0].user
        this.user2 = str2.substr(0, 3) + '********'
        this.content2 = ret[0].data[0].content
      })
    },
    // 矿业设备
    getKysb(item, index)
    {
      $(`.sameline4 ul li`).css({'font-weight': '500', 'color': 'rgb(131, 130, 130)'})
      $(`.sameline4 ul li:nth-child(${index + 1})`).css({'font-weight': '600', 'color': 'rgb(31, 104, 192)'})
      if (index === 0)
      {
        let paras = {cmd: 'query', _major: 11, _minor: 18, _exp: 'id>0 and examine = 0', orderby: 'addtime Desc', init: 0, pageno: 1, pagesize: 10}
        window.post.getPost(paras).then((ret) =>
        {
          this.swiperGroupKYSB = []
          ret[0].data.forEach(item =>
          {
            this.swiperGroupKYSB.push({id: item.id, title: item.title, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', hits: item.hits, species: item.xiangmuleibie, cooperation: item.hezuofangshi, category: item.kuangchanzhonglei, time: item.adddate, area: item.diliweizhi, company: item.company})
          })
        })
      }
      else if (index === 3)
      {
        let paras = {cmd: 'query', _major: 11, _minor: 20, _exp: 'id>0 and examine = 0', orderby: 'addtime Desc', init: 0, pageno: 1, pagesize: 10}
        window.post.getPost(paras).then((ret) =>
        {
          this.swiperGroupKYSB = []
          ret[0].data.forEach(item =>
          {
            this.swiperGroupKYSB.push({id: item.id, title: item.title, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', hits: item.hits, species: item.xiangmuleibie, cooperation: item.hezuofangshi, category: item.kuangchanzhonglei, time: item.adddate, area: item.diliweizhi, company: item.company})
          })
        })
      }
      else
      {
        let paras = {cmd: 'query', _major: 11, _minor: 18, _exp: `catid=${item.catid} and examine = 0`, orderby: 'addtime Desc', init: 0, pageno: 1, pagesize: 10}
        window.post.getPost(paras).then((ret) =>
        {
          this.swiperGroupKYSB = []
          ret[0].data.forEach(item =>
          {
            this.swiperGroupKYSB.push({id: item.id, title: item.title, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', hits: item.hits, species: item.xiangmuleibie, cooperation: item.hezuofangshi, category: item.kuangchanzhonglei, time: item.adddate, area: item.diliweizhi, company: item.company})
          })
        })
      }
      this.currentType = item.name //暂存当前点击的类别
    },
    // 珠宝玉石
    getZbys(item, index)
    {
      $(`.sameline5 ul li`).css({'font-weight': '500', 'color': 'rgb(131, 130, 130)'})
      $(`.sameline5 ul li:nth-child(${index + 1})`).css({'font-weight': '600', 'color': 'rgb(31, 104, 192)'})
      if (index === 0)
      {
        let paras = {cmd: 'query', _major: 11, _minor: 16, _exp: 'id>0 and examine = 0', orderby: 'addtime Desc', init: 0, pageno: 1, pagesize: 10}
        window.post.getPost(paras).then((ret) =>
        {
          this.swiperGroupZBYS = []
          ret[0].data.forEach(item =>
          {
            this.swiperGroupZBYS.push({id: item.id, title: item.title, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', hits: item.hits, species: item.xiangmuleibie, cooperation: item.hezuofangshi, category: item.kuangchanzhonglei, time: item.adddate, area: item.diliweizhi, company: item.company})
          })
        })
      }
      else
      {
        let paras = {cmd: 'query', _major: 11, _minor: 16, _exp: `catid=${item.catid} and examine = 0`, orderby: 'addtime Desc', init: 0, pageno: 1, pagesize: 10}
        window.post.getPost(paras).then((ret) =>
        {
          this.swiperGroupZBYS = []
          ret[0].data.forEach(item =>
          {
            this.swiperGroupZBYS.push({id: item.id, title: item.title, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', hits: item.hits, species: item.xiangmuleibie, cooperation: item.hezuofangshi, category: item.kuangchanzhonglei, time: item.adddate, area: item.diliweizhi, company: item.company})
          })
        })
      }
    },
    //矿业设备列表页
    onKysbList()
    {
      if (this.currentType === '药剂溶剂')
      {
        let url = this.$router.resolve({path: '/HzxmKYJSList'})
        window.open(url.href, '_blank')
      }
      else
      {
        let url = this.$router.resolve({path: '/HzxmKYSBList'})
        window.open(url.href, '_blank')
      }
    },
    onZbysList()
    {
      let url = this.$router.resolve({path: '/HzxmZBYSList'})
      window.open(url.href, '_blank')
    },
    //跳转矿业设备详情页
    onclickSwiperKYSB(item)
    {
      if (this.currentType === '药剂溶剂')
      {
        let url = this.$router.resolve({path: '/HzxmKYJSDetails', query: {company: item.company, id: item.id}})
        window.open(url.href, '_blank')
      }
      else
      {
        let url = this.$router.resolve({path: '/HzxmKYSBDetails', query: {company: item.company, id: item.id}})
        window.open(url.href, '_blank')
      }
    },
    onclickSwiperZBYS(item)
    {
      let url = this.$router.resolve({path: '/HzxmZBYSDetails', query: {company: item.company, id: item.id}})
      window.open(url.href, '_blank')
    },
    /** 首页图片 */
    prevVideo2()
    {
      if (this.marginLeftP >= 0)
        return false
      this.marginLeftP += 149
    },
    nextVideo2()
    {
      if (this.marginLeftP <= -((this.photoList.length - 4) * 149))
        return false
      this.marginLeftP -= 149
    },
    mouseOver2()
    {
      this.isShow2 = true
    },
    mouseLeave2()
    {
      this.isShow2 = false
    },
    getPhotoList()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 112, _exp: 'id>0', orderby: 'orders ASC', init: 0, pageno: 1, pagesize: 10}
      window.post.getPost(paras).then((ret) =>
      {
        this.photoList = ret[0].data
        this.photo = this.photoList[0].thumb
        this.photoTitle = this.photoList[0].title
        this.photoid = this.photoList[0].id
      })
    },
    getPIC(item)
    {
      let paras = {cmd: 'query', _major: 11, _minor: 112, _exp: 'id=?', types: 'i', vals: item.id, init: 0, pageno: 1, pagesize: 1}
      window.post.getPost(paras).then((ret) =>
      {
        this.photo = ret[0].data[0].thumb
        this.photoTitle = ret[0].data[0].title
        this.photoid = ret[0].data[0].id
      })
    },
    //视频图片
    getPicList()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 56, _exp: 'type=?', types: 's', vals: '2', orderby: 'orders ASC', init: 0, pageno: 1, pagesize: 10}
      window.post.getPost(paras).then((ret) =>
      {
        this.videoList = ret[0].data
        this.getPlayerOptions(this.videoList[0])
      })
    },
    //视频
    getPlayerOptions(item)
    {
      let paras = {cmd: 'query', _major: 11, _minor: 56, _exp: 'id=?', types: 'i', vals: item.id, init: 0, pageno: 1, pagesize: 1}
      window.post.getPost(paras).then((ret) =>
      {
        this.playerOptions.sources[0].src = ret[0].data[0].video
      })
    },
    prevVideo()
    {
      if (this.marginLeft0 >= 0)
        return false
      this.marginLeft0 += 149
    },
    nextVideo()
    {
      if (this.marginLeft0 <= -((this.videoList.length - 4) * 149))
        return false
      this.marginLeft0 -= 149
    },
    mouseOver()
    {
      this.isShow = true
    },
    mouseLeave()
    {
      this.isShow = false
    },
    /** 矿业资讯服务与法律服务的显隐 */
    show()
    {
      this.ready = true
    },
    hide()
    {
      this.ready = false
      this.isdialogVisible1 = false
      this.isdialogVisible2 = false
    },
    /** 组织 */
    mouseOverZZ()
    {
      this.isZZBoxShow = true
    },
    mouseLeaveZZ()
    {
      this.isZZBoxShow = false
    },
    selectZZ(index)
    {
      this.isZZshow = index
      this.getzzList(index)
    },
    getzzList(num)
    {
      let paras = {cmd: 'query', _major: 11, _minor: 113, _exp: 'type=?', types: 'i', vals: num, init: 0, pageno: 1, pagesize: 10}
      window.post.getPost(paras).then((ret) =>
      {
        this.zzList = ret[0].data
      })
    },
    goZZ(str)
    {
      window.open(str, '_blank')
    },

    goPhotoList(val)
    {
      let url = this.$router.resolve({path: '/SYphotoDetails', query: {id: val}})
      window.open(url.href, '_blank')
    },
    // 消息中心
    openMessage()
    {
      if (!localStorage.getItem('username'))
      {
        this.$message({message: '请您先登录', type: 'error', customClass: 'mzindex'})
        this.$router.push('/loginIndex')//拦截成功后需要跳转的页面
      }
      else
      {
        if (this.ismesssageShow === true)
          this.ismesssageShow = false
        else
        {
          this.isfeedBack = false
          this.isopenKyzxfwShow = false
          this.islegalShow = false
          this.iscomProblemShow = false
          this.ismesssageShow = true
        }
      }
    },
    // 矿业咨询服务
    openKyzxfw()
    {
      this.isdialogVisible1 = true
      // if (!localStorage.getItem('username'))
      // {
      //   this.$message({message: '请您先登录', type: 'error', customClass: 'mzindex'})
      //   this.$router.push('/loginIndex')//拦截成功后需要跳转的页面
      // }
      // else
      // {
      //   if (this.isopenKyzxfwShow === true)
      //     this.isopenKyzxfwShow = false
      //   else
      //   {
      //     this.isopenKyzxfwShow = true
      //     this.isfeedBack = false
      //     this.islegalShow = false
      //     this.iscomProblemShow = false
      //     this.ismesssageShow = false
      //   }
      // }
    },
    // 矿业咨询服务
    openKyzxfws()
    {
      if (!localStorage.getItem('username'))
      {
        this.$message({message: '请您先登录', type: 'error', customClass: 'mzindex'})
        this.$router.push('/loginIndex')//拦截成功后需要跳转的页面
      }
      else
      {
        if (this.isopenKyzxfwShow === true)
          this.isopenKyzxfwShow = false
        else
        {
          this.isopenKyzxfwShow = true
          this.isfeedBack = false
          this.islegalShow = false
          this.iscomProblemShow = false
          this.ismesssageShow = false
        }
      }
    },
    // 法律服务
    openFlfw()
    {
      this.isdialogVisible2 = true
    },
    openFlfws()
    {
      if (!localStorage.getItem('username'))
      {
        this.$message({message: '请您先登录', type: 'error', customClass: 'mzindex'})
        this.$router.push('/loginIndex')//拦截成功后需要跳转的页面
      }
      else
      {
        if (this.islegalShow === true)
          this.islegalShow = false
        else
        {
          this.islegalShow = true
          this.isopenKyzxfwShow = false
          this.isfeedBack = false
          this.iscomProblemShow = false
          this.ismesssageShow = false
        }
      }
    },
    // 反馈及建议
    feedBack()
    {
      if (!localStorage.getItem('username'))
      {
        this.$message({message: '请您先登录', type: 'error', customClass: 'mzindex'})
        this.$router.push('/loginIndex')//拦截成功后需要跳转的页面
      }
      else
      {
        if (this.isfeedBack === true)
          this.isfeedBack = false
        else
        {
          this.isopenKyzxfwShow = false
          this.isfeedBack = true
          this.islegalShow = false
          this.iscomProblemShow = false
          this.ismesssageShow = false
        }
      }
    },
    // 常见问题
    comProblem()
    {
      this.$router.push('/CjwtList')//拦截成功后需要跳转的页面
    },
    showMessage()
    {
      this.isdialogVisible1 = false
      this.isdialogVisible2 = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/KyforumApp.vue